//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    registerCustomer(command: RegisterCustomerCommand, cancelToken?: CancelToken): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/Account/customer/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterCustomer(_response);
        });
    }

    protected processRegisterCustomer(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }

    confirmAccount(id: string | null | undefined, token: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Account/confirm?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmAccount(_response);
        });
    }

    protected processConfirmAccount(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateAccount(command: UpdateAccountCommand, cancelToken?: CancelToken): Promise<ServiceResultOfUserDto> {
        let url_ = this.baseUrl + "/api/Account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAccount(_response);
        });
    }

    protected processUpdateAccount(response: AxiosResponse): Promise<ServiceResultOfUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfUserDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfUserDto>(null as any);
    }

    deleteAccount(id: string | null | undefined, cancelToken?: CancelToken): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/Account?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccount(_response);
        });
    }

    protected processDeleteAccount(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }

    registerAccount(command: CreateAccountCommand, cancelToken?: CancelToken): Promise<ServiceResultOfUserDto> {
        let url_ = this.baseUrl + "/api/Account/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterAccount(_response);
        });
    }

    protected processRegisterAccount(response: AxiosResponse): Promise<ServiceResultOfUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfUserDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfUserDto>(null as any);
    }

    reactivateAccount(command: ReactivateAccountCommand, cancelToken?: CancelToken): Promise<ServiceResultOfUserDto> {
        let url_ = this.baseUrl + "/api/Account/reactivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReactivateAccount(_response);
        });
    }

    protected processReactivateAccount(response: AxiosResponse): Promise<ServiceResultOfUserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfUserDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfUserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfUserDto>(null as any);
    }

    changePassword(command: ChangePasswordCommand, cancelToken?: CancelToken): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/Account/pass/change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }

    resetPassword(command: ResetPasswordCommand, cancelToken?: CancelToken): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/Account/pass/reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }

    getAll( cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/Account/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    export(command: ExportAccountsCommand, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Account/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class AuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    login(command: LoginUserCommand, cancelToken?: CancelToken): Promise<AuthenticationResult> {
        let url_ = this.baseUrl + "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<AuthenticationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticationResult.fromJS(resultData200);
            return Promise.resolve<AuthenticationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationResult>(null as any);
    }

    refresh(command: RefreshUserCommand, cancelToken?: CancelToken): Promise<AuthenticationResult> {
        let url_ = this.baseUrl + "/api/Auth/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefresh(_response);
        });
    }

    protected processRefresh(response: AxiosResponse): Promise<AuthenticationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthenticationResult.fromJS(resultData200);
            return Promise.resolve<AuthenticationResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthenticationResult>(null as any);
    }
}

export class ContactFormClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    contactformPresentaid(command: ContactformDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ContactForm/contactPresentaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContactformPresentaid(_response);
        });
    }

    protected processContactformPresentaid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DashboardClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    getAccountStatistic(userId: number, cancelToken?: CancelToken): Promise<UserStatistic> {
        let url_ = this.baseUrl + "/api/Dashboard/statistic/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountStatistic(_response);
        });
    }

    protected processGetAccountStatistic(response: AxiosResponse): Promise<UserStatistic> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserStatistic.fromJS(resultData200);
            return Promise.resolve<UserStatistic>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserStatistic>(null as any);
    }

    getLatestCreatedAccounts( cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/Dashboard/statistic/created";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestCreatedAccounts(_response);
        });
    }

    protected processGetLatestCreatedAccounts(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    getLatestActivations( cancelToken?: CancelToken): Promise<LicenseActivationDto[]> {
        let url_ = this.baseUrl + "/api/Dashboard/statistic/latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestActivations(_response);
        });
    }

    protected processGetLatestActivations(response: AxiosResponse): Promise<LicenseActivationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseActivationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LicenseActivationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenseActivationDto[]>(null as any);
    }

    getLatestValidations( cancelToken?: CancelToken): Promise<LicenseActivationDto[]> {
        let url_ = this.baseUrl + "/api/Dashboard/statistic/latestValidations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestValidations(_response);
        });
    }

    protected processGetLatestValidations(response: AxiosResponse): Promise<LicenseActivationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseActivationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LicenseActivationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenseActivationDto[]>(null as any);
    }

    getExpiringLicenses( cancelToken?: CancelToken): Promise<LicenseDto[]> {
        let url_ = this.baseUrl + "/api/Dashboard/statistic/expiringLicenses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExpiringLicenses(_response);
        });
    }

    protected processGetExpiringLicenses(response: AxiosResponse): Promise<LicenseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LicenseDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenseDto[]>(null as any);
    }

    getActiveEntities(query: ActiveEntitiesQuery, cancelToken?: CancelToken): Promise<ActiveEntitiesSummary> {
        let url_ = this.baseUrl + "/api/Dashboard/statistic/active";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveEntities(_response);
        });
    }

    protected processGetActiveEntities(response: AxiosResponse): Promise<ActiveEntitiesSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveEntitiesSummary.fromJS(resultData200);
            return Promise.resolve<ActiveEntitiesSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveEntitiesSummary>(null as any);
    }
}

export class LicenseActivationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    getLicenseActivations(licenseId: number, cancelToken?: CancelToken): Promise<LicenseActivationDto[]> {
        let url_ = this.baseUrl + "/api/LicenseActivation/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseActivations(_response);
        });
    }

    protected processGetLicenseActivations(response: AxiosResponse): Promise<LicenseActivationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseActivationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LicenseActivationDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenseActivationDto[]>(null as any);
    }

    deleteLicenseActivation(activationId: number | undefined, cancelToken?: CancelToken): Promise<ServiceResultIds> {
        let url_ = this.baseUrl + "/api/LicenseActivation?";
        if (activationId === null)
            throw new Error("The parameter 'activationId' cannot be null.");
        else if (activationId !== undefined)
            url_ += "activationId=" + encodeURIComponent("" + activationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLicenseActivation(_response);
        });
    }

    protected processDeleteLicenseActivation(response: AxiosResponse): Promise<ServiceResultIds> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultIds.fromJS(resultData200);
            return Promise.resolve<ServiceResultIds>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultIds>(null as any);
    }

    export(command: ExportLicensesActivationCommand, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LicenseActivation/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    clientExport(command: ExportLicensesActivationCommand, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/LicenseActivation/clientexport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClientExport(_response);
        });
    }

    protected processClientExport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class LicenseActivationIntegrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    getPublicKey( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PublicKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicKey(_response);
        });
    }

    protected processGetPublicKey(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    activateLicense( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ActivationRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateLicense(_response);
        });
    }

    protected processActivateLicense(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    validateActivation( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ActivationValidate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateActivation(_response);
        });
    }

    protected processValidateActivation(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class LicenseClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    getAccountLicenses(accountId: number, cancelToken?: CancelToken): Promise<LicenseDto[]> {
        let url_ = this.baseUrl + "/api/License/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountLicenses(_response);
        });
    }

    protected processGetAccountLicenses(response: AxiosResponse): Promise<LicenseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LicenseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LicenseDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenseDto[]>(null as any);
    }

    getAvailableProducts( cancelToken?: CancelToken): Promise<ProductDto[]> {
        let url_ = this.baseUrl + "/api/License/products";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableProducts(_response);
        });
    }

    protected processGetAvailableProducts(response: AxiosResponse): Promise<ProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDto[]>(null as any);
    }

    getAvailableLicenseTypes( cancelToken?: CancelToken): Promise<ProductDto[]> {
        let url_ = this.baseUrl + "/api/License/license-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAvailableLicenseTypes(_response);
        });
    }

    protected processGetAvailableLicenseTypes(response: AxiosResponse): Promise<ProductDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductDto[]>(null as any);
    }

    createLicense(command: CreateLicenseCommand, cancelToken?: CancelToken): Promise<ServiceResultOfLicenseDto> {
        let url_ = this.baseUrl + "/api/License";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateLicense(_response);
        });
    }

    protected processCreateLicense(response: AxiosResponse): Promise<ServiceResultOfLicenseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfLicenseDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfLicenseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfLicenseDto>(null as any);
    }

    updateLicense(command: UpdateLicenseCommand, cancelToken?: CancelToken): Promise<ServiceResultOfLicenseDto> {
        let url_ = this.baseUrl + "/api/License";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateLicense(_response);
        });
    }

    protected processUpdateLicense(response: AxiosResponse): Promise<ServiceResultOfLicenseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultOfLicenseDto.fromJS(resultData200);
            return Promise.resolve<ServiceResultOfLicenseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultOfLicenseDto>(null as any);
    }

    deleteLicense(licenseId: number | undefined, cancelToken?: CancelToken): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/License?";
        if (licenseId === null)
            throw new Error("The parameter 'licenseId' cannot be null.");
        else if (licenseId !== undefined)
            url_ += "licenseId=" + encodeURIComponent("" + licenseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLicense(_response);
        });
    }

    protected processDeleteLicense(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }

    sendLicenseEmail(command: SendLicenseEmailCommand, cancelToken?: CancelToken): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/License/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendLicenseEmail(_response);
        });
    }

    protected processSendLicenseEmail(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }

    export(command: ExportLicensesCommand, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/License/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class MailSchedulerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    options( cancelToken?: CancelToken): Promise<MailSchedulerOptionsDto> {
        let url_ = this.baseUrl + "/api/MailScheduler/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOptions(_response);
        });
    }

    protected processOptions(response: AxiosResponse): Promise<MailSchedulerOptionsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailSchedulerOptionsDto.fromJS(resultData200);
            return Promise.resolve<MailSchedulerOptionsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailSchedulerOptionsDto>(null as any);
    }

    run(request: RunMailSchedulerRequest, cancelToken?: CancelToken): Promise<MailSchedulerRunResult> {
        let url_ = this.baseUrl + "/api/MailScheduler/run";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRun(_response);
        });
    }

    protected processRun(response: AxiosResponse): Promise<MailSchedulerRunResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailSchedulerRunResult.fromJS(resultData200);
            return Promise.resolve<MailSchedulerRunResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailSchedulerRunResult>(null as any);
    }

    run2(request: RunMailSchedulerRequest, cancelToken?: CancelToken): Promise<MailSchedulerRunStartResult> {
        let url_ = this.baseUrl + "/api/MailScheduler/run-async";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRun2(_response);
        });
    }

    protected processRun2(response: AxiosResponse): Promise<MailSchedulerRunStartResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailSchedulerRunStartResult.fromJS(resultData200);
            return Promise.resolve<MailSchedulerRunStartResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailSchedulerRunStartResult>(null as any);
    }

    progress(jobId: string, cancelToken?: CancelToken): Promise<MailSchedulerRunProgress> {
        let url_ = this.baseUrl + "/api/MailScheduler/progress/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProgress(_response);
        });
    }

    protected processProgress(response: AxiosResponse): Promise<MailSchedulerRunProgress> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailSchedulerRunProgress.fromJS(resultData200);
            return Promise.resolve<MailSchedulerRunProgress>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailSchedulerRunProgress>(null as any);
    }

    preview(routine: MailSchedulerRoutine | undefined, index: number | undefined, cancelToken?: CancelToken): Promise<MailPreviewDto> {
        let url_ = this.baseUrl + "/api/MailScheduler/preview?";
        if (routine === null)
            throw new Error("The parameter 'routine' cannot be null.");
        else if (routine !== undefined)
            url_ += "routine=" + encodeURIComponent("" + routine) + "&";
        if (index === null)
            throw new Error("The parameter 'index' cannot be null.");
        else if (index !== undefined)
            url_ += "index=" + encodeURIComponent("" + index) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreview(_response);
        });
    }

    protected processPreview(response: AxiosResponse): Promise<MailPreviewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MailPreviewDto.fromJS(resultData200);
            return Promise.resolve<MailPreviewDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailPreviewDto>(null as any);
    }
}

export class MailSenderClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    unsubscribe(userId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/unsubscribe?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnsubscribe(_response);
        });
    }

    protected processUnsubscribe(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    get( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PipedriveClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    pushToPipedrive(command: PipedriveComboCommand, cancelToken?: CancelToken): Promise<ServiceResultPipedrive> {
        let url_ = this.baseUrl + "/api/Pipedrive/pushToPipedrive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPushToPipedrive(_response);
        });
    }

    protected processPushToPipedrive(response: AxiosResponse): Promise<ServiceResultPipedrive> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResultPipedrive.fromJS(resultData200);
            return Promise.resolve<ServiceResultPipedrive>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResultPipedrive>(null as any);
    }

    addDeal(command: PipedriveDealCommand, cancelToken?: CancelToken): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/Pipedrive/addDeal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddDeal(_response);
        });
    }

    protected processAddDeal(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }

    addOrganization(command: PipedriveOrganizationCommand, cancelToken?: CancelToken): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/Pipedrive/addOrganziation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrganization(_response);
        });
    }

    protected processAddOrganization(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }

    addPerson(command: PipedrivePersonCommand, cancelToken?: CancelToken): Promise<ServiceResult> {
        let url_ = this.baseUrl + "/api/Pipedrive/addPerson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPerson(_response);
        });
    }

    protected processAddPerson(response: AxiosResponse): Promise<ServiceResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceResult.fromJS(resultData200);
            return Promise.resolve<ServiceResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceResult>(null as any);
    }
}

export class ReportsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    getActivationLog( cancelToken?: CancelToken): Promise<ActivationLogDto[]> {
        let url_ = this.baseUrl + "/api/Reports/activationlog";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivationLog(_response);
        });
    }

    protected processGetActivationLog(response: AxiosResponse): Promise<ActivationLogDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivationLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActivationLogDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivationLogDto[]>(null as any);
    }

    getErrorsLog( cancelToken?: CancelToken): Promise<ErrorLogDto[]> {
        let url_ = this.baseUrl + "/api/Reports/errorslog";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetErrorsLog(_response);
        });
    }

    protected processGetErrorsLog(response: AxiosResponse): Promise<ErrorLogDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ErrorLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ErrorLogDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ErrorLogDto[]>(null as any);
    }

    getMailLog( cancelToken?: CancelToken): Promise<MailLogDto[]> {
        let url_ = this.baseUrl + "/api/Reports/maillog";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMailLog(_response);
        });
    }

    protected processGetMailLog(response: AxiosResponse): Promise<MailLogDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MailLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MailLogDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailLogDto[]>(null as any);
    }

    deleteMailLogs(ids: number[], cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/maillog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMailLogs(_response);
        });
    }

    protected processDeleteMailLogs(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class WebhookClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    index( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/stripewebhook";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class PaymentIntentApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    create(request: PaymentIntentCreateRequest, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/create-payment-intent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ToolsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:46355";

    }

    migrateOldAccounts( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Tools/migrate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMigrateOldAccounts(_response);
        });
    }

    protected processMigrateOldAccounts(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText: any = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText: any = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ServiceResult implements IServiceResult {
    errors?: string[] | undefined;
    isSuccess!: boolean;

    constructor(data?: IServiceResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): ServiceResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface IServiceResult {
    errors?: string[] | undefined;
    isSuccess: boolean;
}

export class RegisterCustomerCommand implements IRegisterCustomerCommand {
    company?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    createdBy?: string | undefined;

    constructor(data?: IRegisterCustomerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): RegisterCustomerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterCustomerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IRegisterCustomerCommand {
    company?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    createdBy?: string | undefined;
}

export class ServiceResultOfUserDto extends ServiceResult implements IServiceResultOfUserDto {
    entity?: UserDto | undefined;

    constructor(data?: IServiceResultOfUserDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"] ? UserDto.fromJS(_data["entity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceResultOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfUserDto extends IServiceResult {
    entity?: UserDto | undefined;
}

export class UserDto implements IUserDto {
    id!: number;
    email?: string | undefined;
    emailConfirmed!: boolean;
    company?: string | undefined;
    vat?: string | undefined;
    salutation?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    accountConfirmationType!: AccountConfirmation;
    isDeleted!: boolean;
    createdDate!: string;
    createdBy?: string | undefined;
    modifiedDate?: string | undefined;
    modifiedBy?: string | undefined;
    role?: string | undefined;
    licenseExpiryDate!: string;
    activationsCount!: number;
    stripeCustomerId?: string | undefined;
    allowSendMails!: boolean;
    emailsRolloutDate!: string;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.company = _data["company"];
            this.vat = _data["vat"];
            this.salutation = _data["salutation"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.accountConfirmationType = _data["accountConfirmationType"];
            this.isDeleted = _data["isDeleted"];
            this.createdDate = _data["createdDate"];
            this.createdBy = _data["createdBy"];
            this.modifiedDate = _data["modifiedDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.role = _data["role"];
            this.licenseExpiryDate = _data["licenseExpiryDate"];
            this.activationsCount = _data["activationsCount"];
            this.stripeCustomerId = _data["stripeCustomerId"];
            this.allowSendMails = _data["allowSendMails"];
            this.emailsRolloutDate = _data["emailsRolloutDate"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["company"] = this.company;
        data["vat"] = this.vat;
        data["salutation"] = this.salutation;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["accountConfirmationType"] = this.accountConfirmationType;
        data["isDeleted"] = this.isDeleted;
        data["createdDate"] = this.createdDate;
        data["createdBy"] = this.createdBy;
        data["modifiedDate"] = this.modifiedDate;
        data["modifiedBy"] = this.modifiedBy;
        data["role"] = this.role;
        data["licenseExpiryDate"] = this.licenseExpiryDate;
        data["activationsCount"] = this.activationsCount;
        data["stripeCustomerId"] = this.stripeCustomerId;
        data["allowSendMails"] = this.allowSendMails;
        data["emailsRolloutDate"] = this.emailsRolloutDate;
        return data;
    }
}

export interface IUserDto {
    id: number;
    email?: string | undefined;
    emailConfirmed: boolean;
    company?: string | undefined;
    vat?: string | undefined;
    salutation?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    accountConfirmationType: AccountConfirmation;
    isDeleted: boolean;
    createdDate: string;
    createdBy?: string | undefined;
    modifiedDate?: string | undefined;
    modifiedBy?: string | undefined;
    role?: string | undefined;
    licenseExpiryDate: string;
    activationsCount: number;
    stripeCustomerId?: string | undefined;
    allowSendMails: boolean;
    emailsRolloutDate: string;
}

export enum AccountConfirmation {
    None = "None",
    Mail = "Mail",
    MailWithCredentials = "MailWithCredentials",
}

export class CreateAccountCommandBase implements ICreateAccountCommandBase {
    email?: string | undefined;
    isEmailConfirmed!: boolean;
    company?: string | undefined;
    vat?: string | undefined;
    salutation?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    accountRole!: ApplicationRoleType;
    accountConfirmationType!: AccountConfirmation;
    allowSendMails!: boolean;
    emailsRolloutDate!: string;

    constructor(data?: ICreateAccountCommandBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.company = _data["company"];
            this.vat = _data["vat"];
            this.salutation = _data["salutation"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.street = _data["street"];
            this.streetNumber = _data["streetNumber"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.accountRole = _data["accountRole"];
            this.accountConfirmationType = _data["accountConfirmationType"];
            this.allowSendMails = _data["allowSendMails"];
            this.emailsRolloutDate = _data["emailsRolloutDate"];
        }
    }

    static fromJS(data: any): CreateAccountCommandBase {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountCommandBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["company"] = this.company;
        data["vat"] = this.vat;
        data["salutation"] = this.salutation;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["street"] = this.street;
        data["streetNumber"] = this.streetNumber;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["accountRole"] = this.accountRole;
        data["accountConfirmationType"] = this.accountConfirmationType;
        data["allowSendMails"] = this.allowSendMails;
        data["emailsRolloutDate"] = this.emailsRolloutDate;
        return data;
    }
}

export interface ICreateAccountCommandBase {
    email?: string | undefined;
    isEmailConfirmed: boolean;
    company?: string | undefined;
    vat?: string | undefined;
    salutation?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    street?: string | undefined;
    streetNumber?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    accountRole: ApplicationRoleType;
    accountConfirmationType: AccountConfirmation;
    allowSendMails: boolean;
    emailsRolloutDate: string;
}

export class CreateAccountCommand extends CreateAccountCommandBase implements ICreateAccountCommand {
    password?: string | undefined;

    constructor(data?: ICreateAccountCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateAccountCommand extends ICreateAccountCommandBase {
    password?: string | undefined;
}

export class UpdateAccountCommand extends CreateAccountCommand implements IUpdateAccountCommand {
    id!: number;
    stripeAccountId?: string | undefined;
    modifiedBy?: string | undefined;

    constructor(data?: IUpdateAccountCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.stripeAccountId = _data["stripeAccountId"];
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): UpdateAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stripeAccountId"] = this.stripeAccountId;
        data["modifiedBy"] = this.modifiedBy;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateAccountCommand extends ICreateAccountCommand {
    id: number;
    stripeAccountId?: string | undefined;
    modifiedBy?: string | undefined;
}

export enum ApplicationRoleType {
    Customer = "Customer",
    Employee = "Employee",
    Administrator = "Administrator",
    NewsletterRecipient = "NewsletterRecipient",
}

export class ReactivateAccountCommand extends CreateAccountCommand implements IReactivateAccountCommand {
    updateAccountData!: boolean;

    constructor(data?: IReactivateAccountCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.updateAccountData = _data["updateAccountData"];
        }
    }

    static fromJS(data: any): ReactivateAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ReactivateAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateAccountData"] = this.updateAccountData;
        super.toJSON(data);
        return data;
    }
}

export interface IReactivateAccountCommand extends ICreateAccountCommand {
    updateAccountData: boolean;
}

export class ChangePasswordCommand implements IChangePasswordCommand {
    accountId!: number;
    password?: string | undefined;

    constructor(data?: IChangePasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ChangePasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["password"] = this.password;
        return data;
    }
}

export interface IChangePasswordCommand {
    accountId: number;
    password?: string | undefined;
}

export class ResetPasswordCommand implements IResetPasswordCommand {
    email?: string | undefined;

    constructor(data?: IResetPasswordCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ResetPasswordCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IResetPasswordCommand {
    email?: string | undefined;
}

export class ExportAccountsCommand implements IExportAccountsCommand {
    customers?: number[] | undefined;

    constructor(data?: IExportAccountsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(item);
            }
        }
    }

    static fromJS(data: any): ExportAccountsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportAccountsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item);
        }
        return data;
    }
}

export interface IExportAccountsCommand {
    customers?: number[] | undefined;
}

export class AuthenticationResult implements IAuthenticationResult {
    token?: string | undefined;
    refreshToken?: string | undefined;
    isSuccess!: boolean;
    errorMessages?: string[] | undefined;

    constructor(data?: IAuthenticationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
            this.isSuccess = _data["isSuccess"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
        }
    }

    static fromJS(data: any): AuthenticationResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        data["isSuccess"] = this.isSuccess;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data;
    }
}

export interface IAuthenticationResult {
    token?: string | undefined;
    refreshToken?: string | undefined;
    isSuccess: boolean;
    errorMessages?: string[] | undefined;
}

export class LoginUserCommand implements ILoginUserCommand {
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: ILoginUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LoginUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ILoginUserCommand {
    email?: string | undefined;
    password?: string | undefined;
}

export class RefreshUserCommand implements IRefreshUserCommand {
    token?: string | undefined;
    refreshToken?: string | undefined;

    constructor(data?: IRefreshUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshUserCommand {
    token?: string | undefined;
    refreshToken?: string | undefined;
}

export abstract class UserDetailedEmailData implements IUserDetailedEmailData {
    externalUsedId!: string;

    constructor(data?: IUserDetailedEmailData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalUsedId = _data["externalUsedId"];
        }
    }

    static fromJS(data: any): UserDetailedEmailData {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'UserDetailedEmailData' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalUsedId"] = this.externalUsedId;
        return data;
    }
}

export interface IUserDetailedEmailData {
    externalUsedId: string;
}

export class ContactformDto extends UserDetailedEmailData implements IContactformDto {
    company?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    message?: string | undefined;
    privacyPolicyAccepted!: boolean;
    browser?: string | undefined;
    os?: string | undefined;

    constructor(data?: IContactformDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.company = _data["company"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.message = _data["message"];
            this.privacyPolicyAccepted = _data["privacyPolicyAccepted"];
            this.browser = _data["browser"];
            this.os = _data["os"];
        }
    }

    static fromJS(data: any): ContactformDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactformDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["name"] = this.name;
        data["email"] = this.email;
        data["message"] = this.message;
        data["privacyPolicyAccepted"] = this.privacyPolicyAccepted;
        data["browser"] = this.browser;
        data["os"] = this.os;
        super.toJSON(data);
        return data;
    }
}

export interface IContactformDto extends IUserDetailedEmailData {
    company?: string | undefined;
    name?: string | undefined;
    email?: string | undefined;
    message?: string | undefined;
    privacyPolicyAccepted: boolean;
    browser?: string | undefined;
    os?: string | undefined;
}

export class UserStatistic implements IUserStatistic {
    licensesStatistic?: UserLicenseStatistic[] | undefined;
    licenseActivationsStatistic?: UserLicenseActivationsStatistic[] | undefined;

    constructor(data?: IUserStatistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["licensesStatistic"])) {
                this.licensesStatistic = [] as any;
                for (let item of _data["licensesStatistic"])
                    this.licensesStatistic!.push(UserLicenseStatistic.fromJS(item));
            }
            if (Array.isArray(_data["licenseActivationsStatistic"])) {
                this.licenseActivationsStatistic = [] as any;
                for (let item of _data["licenseActivationsStatistic"])
                    this.licenseActivationsStatistic!.push(UserLicenseActivationsStatistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserStatistic {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.licensesStatistic)) {
            data["licensesStatistic"] = [];
            for (let item of this.licensesStatistic)
                data["licensesStatistic"].push(item.toJSON());
        }
        if (Array.isArray(this.licenseActivationsStatistic)) {
            data["licenseActivationsStatistic"] = [];
            for (let item of this.licenseActivationsStatistic)
                data["licenseActivationsStatistic"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserStatistic {
    licensesStatistic?: UserLicenseStatistic[] | undefined;
    licenseActivationsStatistic?: UserLicenseActivationsStatistic[] | undefined;
}

export class UserLicenseStatistic implements IUserLicenseStatistic {
    licenseName?: string | undefined;
    maximumActivations!: number;
    activeActivationsCount!: number;

    constructor(data?: IUserLicenseStatistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseName = _data["licenseName"];
            this.maximumActivations = _data["maximumActivations"];
            this.activeActivationsCount = _data["activeActivationsCount"];
        }
    }

    static fromJS(data: any): UserLicenseStatistic {
        data = typeof data === 'object' ? data : {};
        let result = new UserLicenseStatistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseName"] = this.licenseName;
        data["maximumActivations"] = this.maximumActivations;
        data["activeActivationsCount"] = this.activeActivationsCount;
        return data;
    }
}

export interface IUserLicenseStatistic {
    licenseName?: string | undefined;
    maximumActivations: number;
    activeActivationsCount: number;
}

export class UserLicenseActivationsStatistic implements IUserLicenseActivationsStatistic {
    company?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    computerName?: string | undefined;
    userDomainName?: string | undefined;
    userName?: string | undefined;
    createTime!: string;
    modifiedTime!: string;
    productVersion?: string | undefined;

    constructor(data?: IUserLicenseActivationsStatistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.computerName = _data["computerName"];
            this.userDomainName = _data["userDomainName"];
            this.userName = _data["userName"];
            this.createTime = _data["createTime"];
            this.modifiedTime = _data["modifiedTime"];
            this.productVersion = _data["productVersion"];
        }
    }

    static fromJS(data: any): UserLicenseActivationsStatistic {
        data = typeof data === 'object' ? data : {};
        let result = new UserLicenseActivationsStatistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["computerName"] = this.computerName;
        data["userDomainName"] = this.userDomainName;
        data["userName"] = this.userName;
        data["createTime"] = this.createTime;
        data["modifiedTime"] = this.modifiedTime;
        data["productVersion"] = this.productVersion;
        return data;
    }
}

export interface IUserLicenseActivationsStatistic {
    company?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    computerName?: string | undefined;
    userDomainName?: string | undefined;
    userName?: string | undefined;
    createTime: string;
    modifiedTime: string;
    productVersion?: string | undefined;
}

export class LicenseActivationDto implements ILicenseActivationDto {
    autoId!: number;
    licenseId!: number;
    activationState?: string | undefined;
    state!: ActivationState;
    createTime!: string;
    modifiedTime!: string;
    activationInfo?: MagicDto | undefined;
    magic?: string | undefined;
    endpoint?: string | undefined;
    company?: string | undefined;
    accountId!: number;
    accountName?: string | undefined;
    accountSurname?: string | undefined;
    accountEmail?: string | undefined;

    constructor(data?: ILicenseActivationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autoId = _data["autoId"];
            this.licenseId = _data["licenseId"];
            this.activationState = _data["activationState"];
            this.state = _data["state"];
            this.createTime = _data["createTime"];
            this.modifiedTime = _data["modifiedTime"];
            this.activationInfo = _data["activationInfo"] ? MagicDto.fromJS(_data["activationInfo"]) : <any>undefined;
            this.magic = _data["magic"];
            this.endpoint = _data["endpoint"];
            this.company = _data["company"];
            this.accountId = _data["accountId"];
            this.accountName = _data["accountName"];
            this.accountSurname = _data["accountSurname"];
            this.accountEmail = _data["accountEmail"];
        }
    }

    static fromJS(data: any): LicenseActivationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseActivationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoId"] = this.autoId;
        data["licenseId"] = this.licenseId;
        data["activationState"] = this.activationState;
        data["state"] = this.state;
        data["createTime"] = this.createTime;
        data["modifiedTime"] = this.modifiedTime;
        data["activationInfo"] = this.activationInfo ? this.activationInfo.toJSON() : <any>undefined;
        data["magic"] = this.magic;
        data["endpoint"] = this.endpoint;
        data["company"] = this.company;
        data["accountId"] = this.accountId;
        data["accountName"] = this.accountName;
        data["accountSurname"] = this.accountSurname;
        data["accountEmail"] = this.accountEmail;
        return data;
    }
}

export interface ILicenseActivationDto {
    autoId: number;
    licenseId: number;
    activationState?: string | undefined;
    state: ActivationState;
    createTime: string;
    modifiedTime: string;
    activationInfo?: MagicDto | undefined;
    magic?: string | undefined;
    endpoint?: string | undefined;
    company?: string | undefined;
    accountId: number;
    accountName?: string | undefined;
    accountSurname?: string | undefined;
    accountEmail?: string | undefined;
}

export enum ActivationState {
    Activated = "Activated",
    MaximumActivationsReached = "MaximumActivationsReached",
    LicenceKeyExpired = "LicenceKeyExpired",
    LicenceOrAccountDeleted = "LicenceOrAccountDeleted",
    AlreadyActivated = "AlreadyActivated",
    DomainMismatch = "DomainMismatch",
}

export class MagicDto implements IMagicDto {
    computerName?: string | undefined;
    userDomainName?: string | undefined;
    userName?: string | undefined;
    productVersion?: string | undefined;
    hostVersion?: string | undefined;
    osVersion?: string | undefined;

    constructor(data?: IMagicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.computerName = _data["computerName"];
            this.userDomainName = _data["userDomainName"];
            this.userName = _data["userName"];
            this.productVersion = _data["productVersion"];
            this.hostVersion = _data["hostVersion"];
            this.osVersion = _data["osVersion"];
        }
    }

    static fromJS(data: any): MagicDto {
        data = typeof data === 'object' ? data : {};
        let result = new MagicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["computerName"] = this.computerName;
        data["userDomainName"] = this.userDomainName;
        data["userName"] = this.userName;
        data["productVersion"] = this.productVersion;
        data["hostVersion"] = this.hostVersion;
        data["osVersion"] = this.osVersion;
        return data;
    }
}

export interface IMagicDto {
    computerName?: string | undefined;
    userDomainName?: string | undefined;
    userName?: string | undefined;
    productVersion?: string | undefined;
    hostVersion?: string | undefined;
    osVersion?: string | undefined;
}

export class LicenseDto implements ILicenseDto {
    id!: number;
    product?: string | undefined;
    type?: string | undefined;
    key?: string | undefined;
    hash?: string | undefined;
    activationsCount!: number;
    maximumActivations!: number;
    createdDate!: string;
    createdBy?: string | undefined;
    expiredDays!: number;
    expiryDate!: string;
    accountId!: number;
    company?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    licenseDomain?: string | undefined;
    modifiedDate!: string;
    modifiedBy?: string | undefined;
    stripeSubscriptionId?: string | undefined;
    stripeCancelAt?: string | undefined;
    stripeSubscriptionStatus?: string | undefined;

    constructor(data?: ILicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.product = _data["product"];
            this.type = _data["type"];
            this.key = _data["key"];
            this.hash = _data["hash"];
            this.activationsCount = _data["activationsCount"];
            this.maximumActivations = _data["maximumActivations"];
            this.createdDate = _data["createdDate"];
            this.createdBy = _data["createdBy"];
            this.expiredDays = _data["expiredDays"];
            this.expiryDate = _data["expiryDate"];
            this.accountId = _data["accountId"];
            this.company = _data["company"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.licenseDomain = _data["licenseDomain"];
            this.modifiedDate = _data["modifiedDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.stripeSubscriptionId = _data["stripeSubscriptionId"];
            this.stripeCancelAt = _data["stripeCancelAt"];
            this.stripeSubscriptionStatus = _data["stripeSubscriptionStatus"];
        }
    }

    static fromJS(data: any): LicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["product"] = this.product;
        data["type"] = this.type;
        data["key"] = this.key;
        data["hash"] = this.hash;
        data["activationsCount"] = this.activationsCount;
        data["maximumActivations"] = this.maximumActivations;
        data["createdDate"] = this.createdDate;
        data["createdBy"] = this.createdBy;
        data["expiredDays"] = this.expiredDays;
        data["expiryDate"] = this.expiryDate;
        data["accountId"] = this.accountId;
        data["company"] = this.company;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["licenseDomain"] = this.licenseDomain;
        data["modifiedDate"] = this.modifiedDate;
        data["modifiedBy"] = this.modifiedBy;
        data["stripeSubscriptionId"] = this.stripeSubscriptionId;
        data["stripeCancelAt"] = this.stripeCancelAt;
        data["stripeSubscriptionStatus"] = this.stripeSubscriptionStatus;
        return data;
    }
}

export interface ILicenseDto {
    id: number;
    product?: string | undefined;
    type?: string | undefined;
    key?: string | undefined;
    hash?: string | undefined;
    activationsCount: number;
    maximumActivations: number;
    createdDate: string;
    createdBy?: string | undefined;
    expiredDays: number;
    expiryDate: string;
    accountId: number;
    company?: string | undefined;
    name?: string | undefined;
    surname?: string | undefined;
    email?: string | undefined;
    licenseDomain?: string | undefined;
    modifiedDate: string;
    modifiedBy?: string | undefined;
    stripeSubscriptionId?: string | undefined;
    stripeCancelAt?: string | undefined;
    stripeSubscriptionStatus?: string | undefined;
}

export class ActiveEntitiesSummary implements IActiveEntitiesSummary {
    dates?: string[] | undefined;
    activeLicenses?: ActiveEntityModel[] | undefined;
    activeAccounts?: ActiveEntityModel[] | undefined;
    accountsAccumulated?: ActiveEntityModel[] | undefined;
    licensesAccumulated?: ActiveEntityModel[] | undefined;
    activationsAccumulated?: ActiveEntityModel[] | undefined;

    constructor(data?: IActiveEntitiesSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(item);
            }
            if (Array.isArray(_data["activeLicenses"])) {
                this.activeLicenses = [] as any;
                for (let item of _data["activeLicenses"])
                    this.activeLicenses!.push(ActiveEntityModel.fromJS(item));
            }
            if (Array.isArray(_data["activeAccounts"])) {
                this.activeAccounts = [] as any;
                for (let item of _data["activeAccounts"])
                    this.activeAccounts!.push(ActiveEntityModel.fromJS(item));
            }
            if (Array.isArray(_data["accountsAccumulated"])) {
                this.accountsAccumulated = [] as any;
                for (let item of _data["accountsAccumulated"])
                    this.accountsAccumulated!.push(ActiveEntityModel.fromJS(item));
            }
            if (Array.isArray(_data["licensesAccumulated"])) {
                this.licensesAccumulated = [] as any;
                for (let item of _data["licensesAccumulated"])
                    this.licensesAccumulated!.push(ActiveEntityModel.fromJS(item));
            }
            if (Array.isArray(_data["activationsAccumulated"])) {
                this.activationsAccumulated = [] as any;
                for (let item of _data["activationsAccumulated"])
                    this.activationsAccumulated!.push(ActiveEntityModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActiveEntitiesSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveEntitiesSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item);
        }
        if (Array.isArray(this.activeLicenses)) {
            data["activeLicenses"] = [];
            for (let item of this.activeLicenses)
                data["activeLicenses"].push(item.toJSON());
        }
        if (Array.isArray(this.activeAccounts)) {
            data["activeAccounts"] = [];
            for (let item of this.activeAccounts)
                data["activeAccounts"].push(item.toJSON());
        }
        if (Array.isArray(this.accountsAccumulated)) {
            data["accountsAccumulated"] = [];
            for (let item of this.accountsAccumulated)
                data["accountsAccumulated"].push(item.toJSON());
        }
        if (Array.isArray(this.licensesAccumulated)) {
            data["licensesAccumulated"] = [];
            for (let item of this.licensesAccumulated)
                data["licensesAccumulated"].push(item.toJSON());
        }
        if (Array.isArray(this.activationsAccumulated)) {
            data["activationsAccumulated"] = [];
            for (let item of this.activationsAccumulated)
                data["activationsAccumulated"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActiveEntitiesSummary {
    dates?: string[] | undefined;
    activeLicenses?: ActiveEntityModel[] | undefined;
    activeAccounts?: ActiveEntityModel[] | undefined;
    accountsAccumulated?: ActiveEntityModel[] | undefined;
    licensesAccumulated?: ActiveEntityModel[] | undefined;
    activationsAccumulated?: ActiveEntityModel[] | undefined;
}

export class ActiveEntityModel implements IActiveEntityModel {
    date!: string;
    count!: number;

    constructor(data?: IActiveEntityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ActiveEntityModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveEntityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["count"] = this.count;
        return data;
    }
}

export interface IActiveEntityModel {
    date: string;
    count: number;
}

export class ActiveEntitiesQuery implements IActiveEntitiesQuery {
    from!: string;
    to!: string;

    constructor(data?: IActiveEntitiesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
        }
    }

    static fromJS(data: any): ActiveEntitiesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveEntitiesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        return data;
    }
}

export interface IActiveEntitiesQuery {
    from: string;
    to: string;
}

export class ServiceResultIds extends ServiceResult implements IServiceResultIds {
    ids?: number[] | undefined;

    constructor(data?: IServiceResultIds) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceResultIds {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultIds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultIds extends IServiceResult {
    ids?: number[] | undefined;
}

export class ExportLicensesActivationCommand implements IExportLicensesActivationCommand {
    licenseActivationIds?: number[] | undefined;

    constructor(data?: IExportLicensesActivationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["licenseActivationIds"])) {
                this.licenseActivationIds = [] as any;
                for (let item of _data["licenseActivationIds"])
                    this.licenseActivationIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExportLicensesActivationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportLicensesActivationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.licenseActivationIds)) {
            data["licenseActivationIds"] = [];
            for (let item of this.licenseActivationIds)
                data["licenseActivationIds"].push(item);
        }
        return data;
    }
}

export interface IExportLicensesActivationCommand {
    licenseActivationIds?: number[] | undefined;
}

export class ProductDto implements IProductDto {
    id!: string;
    name?: string | undefined;
    value!: number;

    constructor(data?: IProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IProductDto {
    id: string;
    name?: string | undefined;
    value: number;
}

export class ServiceResultOfLicenseDto extends ServiceResult implements IServiceResultOfLicenseDto {
    entity?: LicenseDto | undefined;

    constructor(data?: IServiceResultOfLicenseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entity = _data["entity"] ? LicenseDto.fromJS(_data["entity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceResultOfLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultOfLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultOfLicenseDto extends IServiceResult {
    entity?: LicenseDto | undefined;
}

export abstract class LicenseCommandBase implements ILicenseCommandBase {
    accountId!: number;
    maximumActivations!: number;
    licenseDomain?: string | undefined;
    licenseType?: string | undefined;
    expiredDays!: number;
    expiryDate!: string;

    constructor(data?: ILicenseCommandBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.maximumActivations = _data["maximumActivations"];
            this.licenseDomain = _data["licenseDomain"];
            this.licenseType = _data["licenseType"];
            this.expiredDays = _data["expiredDays"];
            this.expiryDate = _data["expiryDate"];
        }
    }

    static fromJS(data: any): LicenseCommandBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'LicenseCommandBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["maximumActivations"] = this.maximumActivations;
        data["licenseDomain"] = this.licenseDomain;
        data["licenseType"] = this.licenseType;
        data["expiredDays"] = this.expiredDays;
        data["expiryDate"] = this.expiryDate;
        return data;
    }
}

export interface ILicenseCommandBase {
    accountId: number;
    maximumActivations: number;
    licenseDomain?: string | undefined;
    licenseType?: string | undefined;
    expiredDays: number;
    expiryDate: string;
}

export class CreateLicenseCommand extends LicenseCommandBase implements ICreateLicenseCommand {
    productName?: string | undefined;
    createdBy?: string | undefined;
    stripeSubscriptionId?: string | undefined;
    stripeSubscriptionStatus?: string | undefined;
    stripeCancelDate?: string | undefined;

    constructor(data?: ICreateLicenseCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.productName = _data["productName"];
            this.createdBy = _data["createdBy"];
            this.stripeSubscriptionId = _data["stripeSubscriptionId"];
            this.stripeSubscriptionStatus = _data["stripeSubscriptionStatus"];
            this.stripeCancelDate = _data["stripeCancelDate"];
        }
    }

    static fromJS(data: any): CreateLicenseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLicenseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productName"] = this.productName;
        data["createdBy"] = this.createdBy;
        data["stripeSubscriptionId"] = this.stripeSubscriptionId;
        data["stripeSubscriptionStatus"] = this.stripeSubscriptionStatus;
        data["stripeCancelDate"] = this.stripeCancelDate;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateLicenseCommand extends ILicenseCommandBase {
    productName?: string | undefined;
    createdBy?: string | undefined;
    stripeSubscriptionId?: string | undefined;
    stripeSubscriptionStatus?: string | undefined;
    stripeCancelDate?: string | undefined;
}

export class UpdateLicenseCommand extends LicenseCommandBase implements IUpdateLicenseCommand {
    licenseId!: number;
    modifiedBy?: string | undefined;
    stripeSubscriptionId?: string | undefined;
    stripeSubscriptionStatus?: string | undefined;
    stripeCancelDate?: string | undefined;

    constructor(data?: IUpdateLicenseCommand) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.modifiedBy = _data["modifiedBy"];
            this.stripeSubscriptionId = _data["stripeSubscriptionId"];
            this.stripeSubscriptionStatus = _data["stripeSubscriptionStatus"];
            this.stripeCancelDate = _data["stripeCancelDate"];
        }
    }

    static fromJS(data: any): UpdateLicenseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLicenseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["modifiedBy"] = this.modifiedBy;
        data["stripeSubscriptionId"] = this.stripeSubscriptionId;
        data["stripeSubscriptionStatus"] = this.stripeSubscriptionStatus;
        data["stripeCancelDate"] = this.stripeCancelDate;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateLicenseCommand extends ILicenseCommandBase {
    licenseId: number;
    modifiedBy?: string | undefined;
    stripeSubscriptionId?: string | undefined;
    stripeSubscriptionStatus?: string | undefined;
    stripeCancelDate?: string | undefined;
}

export class SendLicenseEmailCommand implements ISendLicenseEmailCommand {
    receiverId!: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    subject?: string | undefined;
    licenseKey?: string | undefined;
    expirationDate!: string;
    maxActivations!: number;
    licenseMailTemplate!: LicenseMailTemplate;

    constructor(data?: ISendLicenseEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiverId = _data["receiverId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.subject = _data["subject"];
            this.licenseKey = _data["licenseKey"];
            this.expirationDate = _data["expirationDate"];
            this.maxActivations = _data["maxActivations"];
            this.licenseMailTemplate = _data["licenseMailTemplate"];
        }
    }

    static fromJS(data: any): SendLicenseEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendLicenseEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiverId"] = this.receiverId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["subject"] = this.subject;
        data["licenseKey"] = this.licenseKey;
        data["expirationDate"] = this.expirationDate;
        data["maxActivations"] = this.maxActivations;
        data["licenseMailTemplate"] = this.licenseMailTemplate;
        return data;
    }
}

export interface ISendLicenseEmailCommand {
    receiverId: number;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    subject?: string | undefined;
    licenseKey?: string | undefined;
    expirationDate: string;
    maxActivations: number;
    licenseMailTemplate: LicenseMailTemplate;
}

export enum LicenseMailTemplate {
    TrialTemplate = "TrialTemplate",
    PurchaseTemplate = "PurchaseTemplate",
    LicenseInformationTemplate = "LicenseInformationTemplate",
}

export class ExportLicensesCommand implements IExportLicensesCommand {
    licenseIds?: number[] | undefined;

    constructor(data?: IExportLicensesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["licenseIds"])) {
                this.licenseIds = [] as any;
                for (let item of _data["licenseIds"])
                    this.licenseIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExportLicensesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ExportLicensesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.licenseIds)) {
            data["licenseIds"] = [];
            for (let item of this.licenseIds)
                data["licenseIds"].push(item);
        }
        return data;
    }
}

export interface IExportLicensesCommand {
    licenseIds?: number[] | undefined;
}

export class MailSchedulerOptionsDto implements IMailSchedulerOptionsDto {
    newsletters?: MailSchedulerOption[] | undefined;
    announcements?: MailSchedulerOption[] | undefined;

    constructor(data?: IMailSchedulerOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["newsletters"])) {
                this.newsletters = [] as any;
                for (let item of _data["newsletters"])
                    this.newsletters!.push(MailSchedulerOption.fromJS(item));
            }
            if (Array.isArray(_data["announcements"])) {
                this.announcements = [] as any;
                for (let item of _data["announcements"])
                    this.announcements!.push(MailSchedulerOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailSchedulerOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailSchedulerOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.newsletters)) {
            data["newsletters"] = [];
            for (let item of this.newsletters)
                data["newsletters"].push(item.toJSON());
        }
        if (Array.isArray(this.announcements)) {
            data["announcements"] = [];
            for (let item of this.announcements)
                data["announcements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMailSchedulerOptionsDto {
    newsletters?: MailSchedulerOption[] | undefined;
    announcements?: MailSchedulerOption[] | undefined;
}

export class MailSchedulerOption implements IMailSchedulerOption {
    index!: number;
    name?: string | undefined;

    constructor(data?: IMailSchedulerOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.index = _data["index"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MailSchedulerOption {
        data = typeof data === 'object' ? data : {};
        let result = new MailSchedulerOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["index"] = this.index;
        data["name"] = this.name;
        return data;
    }
}

export interface IMailSchedulerOption {
    index: number;
    name?: string | undefined;
}

export class MailSchedulerRunResult implements IMailSchedulerRunResult {
    routine!: MailSchedulerRoutine;
    dryRun!: boolean;
    selectedName?: string | undefined;
    recipients?: string[] | undefined;
    stats?: { [key: string]: number; } | undefined;
    totalMails!: number;

    constructor(data?: IMailSchedulerRunResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routine = _data["routine"];
            this.dryRun = _data["dryRun"];
            this.selectedName = _data["selectedName"];
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            if (_data["stats"]) {
                this.stats = {} as any;
                for (let key in _data["stats"]) {
                    if (_data["stats"].hasOwnProperty(key))
                        (<any>this.stats)![key] = _data["stats"][key];
                }
            }
            this.totalMails = _data["totalMails"];
        }
    }

    static fromJS(data: any): MailSchedulerRunResult {
        data = typeof data === 'object' ? data : {};
        let result = new MailSchedulerRunResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routine"] = this.routine;
        data["dryRun"] = this.dryRun;
        data["selectedName"] = this.selectedName;
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        if (this.stats) {
            data["stats"] = {};
            for (let key in this.stats) {
                if (this.stats.hasOwnProperty(key))
                    (<any>data["stats"])[key] = (<any>this.stats)[key];
            }
        }
        data["totalMails"] = this.totalMails;
        return data;
    }
}

export interface IMailSchedulerRunResult {
    routine: MailSchedulerRoutine;
    dryRun: boolean;
    selectedName?: string | undefined;
    recipients?: string[] | undefined;
    stats?: { [key: string]: number; } | undefined;
    totalMails: number;
}

export enum MailSchedulerRoutine {
    Newsletters = "Newsletters",
    Announcement = "Announcement",
}

export class RunMailSchedulerRequest implements IRunMailSchedulerRequest {
    routine!: MailSchedulerRoutine;
    index!: number;
    send!: boolean;

    constructor(data?: IRunMailSchedulerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routine = _data["routine"];
            this.index = _data["index"];
            this.send = _data["send"];
        }
    }

    static fromJS(data: any): RunMailSchedulerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RunMailSchedulerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routine"] = this.routine;
        data["index"] = this.index;
        data["send"] = this.send;
        return data;
    }
}

export interface IRunMailSchedulerRequest {
    routine: MailSchedulerRoutine;
    index: number;
    send: boolean;
}

export class MailSchedulerRunStartResult implements IMailSchedulerRunStartResult {
    jobId?: string | undefined;

    constructor(data?: IMailSchedulerRunStartResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
        }
    }

    static fromJS(data: any): MailSchedulerRunStartResult {
        data = typeof data === 'object' ? data : {};
        let result = new MailSchedulerRunStartResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        return data;
    }
}

export interface IMailSchedulerRunStartResult {
    jobId?: string | undefined;
}

export class MailSchedulerRunProgress implements IMailSchedulerRunProgress {
    jobId?: string | undefined;
    status!: MailSchedulerJobStatus;
    routine!: MailSchedulerRoutine;
    dryRun!: boolean;
    selectedName?: string | undefined;
    total!: number;
    processed!: number;
    sent!: number;
    skipped!: number;
    currentRecipient?: string | undefined;
    error?: string | undefined;
    startedAt!: string;
    updatedAt!: string;
    completedAt?: string | undefined;
    result?: MailSchedulerRunResult | undefined;
    percentComplete!: number;

    constructor(data?: IMailSchedulerRunProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.status = _data["status"];
            this.routine = _data["routine"];
            this.dryRun = _data["dryRun"];
            this.selectedName = _data["selectedName"];
            this.total = _data["total"];
            this.processed = _data["processed"];
            this.sent = _data["sent"];
            this.skipped = _data["skipped"];
            this.currentRecipient = _data["currentRecipient"];
            this.error = _data["error"];
            this.startedAt = _data["startedAt"];
            this.updatedAt = _data["updatedAt"];
            this.completedAt = _data["completedAt"];
            this.result = _data["result"] ? MailSchedulerRunResult.fromJS(_data["result"]) : <any>undefined;
            this.percentComplete = _data["percentComplete"];
        }
    }

    static fromJS(data: any): MailSchedulerRunProgress {
        data = typeof data === 'object' ? data : {};
        let result = new MailSchedulerRunProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["status"] = this.status;
        data["routine"] = this.routine;
        data["dryRun"] = this.dryRun;
        data["selectedName"] = this.selectedName;
        data["total"] = this.total;
        data["processed"] = this.processed;
        data["sent"] = this.sent;
        data["skipped"] = this.skipped;
        data["currentRecipient"] = this.currentRecipient;
        data["error"] = this.error;
        data["startedAt"] = this.startedAt;
        data["updatedAt"] = this.updatedAt;
        data["completedAt"] = this.completedAt;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["percentComplete"] = this.percentComplete;
        return data;
    }
}

export interface IMailSchedulerRunProgress {
    jobId?: string | undefined;
    status: MailSchedulerJobStatus;
    routine: MailSchedulerRoutine;
    dryRun: boolean;
    selectedName?: string | undefined;
    total: number;
    processed: number;
    sent: number;
    skipped: number;
    currentRecipient?: string | undefined;
    error?: string | undefined;
    startedAt: string;
    updatedAt: string;
    completedAt?: string | undefined;
    result?: MailSchedulerRunResult | undefined;
    percentComplete: number;
}

export enum MailSchedulerJobStatus {
    Pending = "Pending",
    Running = "Running",
    Completed = "Completed",
    Failed = "Failed",
}

export class MailPreviewDto implements IMailPreviewDto {
    name?: string | undefined;
    html?: string | undefined;

    constructor(data?: IMailPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.html = _data["html"];
        }
    }

    static fromJS(data: any): MailPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["html"] = this.html;
        return data;
    }
}

export interface IMailPreviewDto {
    name?: string | undefined;
    html?: string | undefined;
}

export class ServiceResultPipedrive extends ServiceResult implements IServiceResultPipedrive {
    pipedriveResponse?: PipedriveResponse | undefined;

    constructor(data?: IServiceResultPipedrive) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pipedriveResponse = _data["pipedriveResponse"] ? PipedriveResponse.fromJS(_data["pipedriveResponse"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceResultPipedrive {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResultPipedrive();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipedriveResponse"] = this.pipedriveResponse ? this.pipedriveResponse.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceResultPipedrive extends IServiceResult {
    pipedriveResponse?: PipedriveResponse | undefined;
}

export class PipedriveResponse implements IPipedriveResponse {
    id!: number;
    name?: string | undefined;

    constructor(data?: IPipedriveResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PipedriveResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PipedriveResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPipedriveResponse {
    id: number;
    name?: string | undefined;
}

export class PipedriveComboCommand implements IPipedriveComboCommand {
    pipedriveDealCommand?: PipedriveDealCommand | undefined;
    pipedriveOrganizationCommand?: PipedriveOrganizationCommand | undefined;
    pipedrivePersonCommand?: PipedrivePersonCommand | undefined;

    constructor(data?: IPipedriveComboCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pipedriveDealCommand = _data["pipedriveDealCommand"] ? PipedriveDealCommand.fromJS(_data["pipedriveDealCommand"]) : <any>undefined;
            this.pipedriveOrganizationCommand = _data["pipedriveOrganizationCommand"] ? PipedriveOrganizationCommand.fromJS(_data["pipedriveOrganizationCommand"]) : <any>undefined;
            this.pipedrivePersonCommand = _data["pipedrivePersonCommand"] ? PipedrivePersonCommand.fromJS(_data["pipedrivePersonCommand"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PipedriveComboCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PipedriveComboCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pipedriveDealCommand"] = this.pipedriveDealCommand ? this.pipedriveDealCommand.toJSON() : <any>undefined;
        data["pipedriveOrganizationCommand"] = this.pipedriveOrganizationCommand ? this.pipedriveOrganizationCommand.toJSON() : <any>undefined;
        data["pipedrivePersonCommand"] = this.pipedrivePersonCommand ? this.pipedrivePersonCommand.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPipedriveComboCommand {
    pipedriveDealCommand?: PipedriveDealCommand | undefined;
    pipedriveOrganizationCommand?: PipedriveOrganizationCommand | undefined;
    pipedrivePersonCommand?: PipedrivePersonCommand | undefined;
}

export class PipedriveDealCommand implements IPipedriveDealCommand {
    title?: string | undefined;
    value?: string | undefined;
    currency?: string | undefined;
    user_id!: number;
    person_id!: number;
    org_id!: number;
    pipeline_id!: number;

    constructor(data?: IPipedriveDealCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.value = _data["value"];
            this.currency = _data["currency"];
            this.user_id = _data["user_id"];
            this.person_id = _data["person_id"];
            this.org_id = _data["org_id"];
            this.pipeline_id = _data["pipeline_id"];
        }
    }

    static fromJS(data: any): PipedriveDealCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PipedriveDealCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["value"] = this.value;
        data["currency"] = this.currency;
        data["user_id"] = this.user_id;
        data["person_id"] = this.person_id;
        data["org_id"] = this.org_id;
        data["pipeline_id"] = this.pipeline_id;
        return data;
    }
}

export interface IPipedriveDealCommand {
    title?: string | undefined;
    value?: string | undefined;
    currency?: string | undefined;
    user_id: number;
    person_id: number;
    org_id: number;
    pipeline_id: number;
}

export class PipedriveOrganizationCommand implements IPipedriveOrganizationCommand {
    name?: string | undefined;
    owner_id!: number;

    constructor(data?: IPipedriveOrganizationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.owner_id = _data["owner_id"];
        }
    }

    static fromJS(data: any): PipedriveOrganizationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PipedriveOrganizationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["owner_id"] = this.owner_id;
        return data;
    }
}

export interface IPipedriveOrganizationCommand {
    name?: string | undefined;
    owner_id: number;
}

export class PipedrivePersonCommand implements IPipedrivePersonCommand {
    name?: string | undefined;
    owner_id!: number;
    org_id!: number;
    email?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IPipedrivePersonCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.owner_id = _data["owner_id"];
            this.org_id = _data["org_id"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): PipedrivePersonCommand {
        data = typeof data === 'object' ? data : {};
        let result = new PipedrivePersonCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["owner_id"] = this.owner_id;
        data["org_id"] = this.org_id;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IPipedrivePersonCommand {
    name?: string | undefined;
    owner_id: number;
    org_id: number;
    email?: string | undefined;
    phone?: string | undefined;
}

export class ActivationLogDto implements IActivationLogDto {
    id!: string;
    eventType!: number;
    event?: string | undefined;
    message?: string | undefined;
    remarks?: string | undefined;
    originAccountId?: number | undefined;
    originAccount?: string | undefined;
    originSessionId?: string | undefined;
    createTime!: string;

    constructor(data?: IActivationLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventType = _data["eventType"];
            this.event = _data["event"];
            this.message = _data["message"];
            this.remarks = _data["remarks"];
            this.originAccountId = _data["originAccountId"];
            this.originAccount = _data["originAccount"];
            this.originSessionId = _data["originSessionId"];
            this.createTime = _data["createTime"];
        }
    }

    static fromJS(data: any): ActivationLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivationLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventType"] = this.eventType;
        data["event"] = this.event;
        data["message"] = this.message;
        data["remarks"] = this.remarks;
        data["originAccountId"] = this.originAccountId;
        data["originAccount"] = this.originAccount;
        data["originSessionId"] = this.originSessionId;
        data["createTime"] = this.createTime;
        return data;
    }
}

export interface IActivationLogDto {
    id: string;
    eventType: number;
    event?: string | undefined;
    message?: string | undefined;
    remarks?: string | undefined;
    originAccountId?: number | undefined;
    originAccount?: string | undefined;
    originSessionId?: string | undefined;
    createTime: string;
}

export class ErrorLogDto implements IErrorLogDto {
    id!: string;
    controller?: string | undefined;
    type?: string | undefined;
    message?: string | undefined;
    trace?: string | undefined;
    data?: string | undefined;
    originAccountId!: number;
    originAccount?: string | undefined;
    originSessionId!: string;
    createTime!: string;

    constructor(data?: IErrorLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.controller = _data["controller"];
            this.type = _data["type"];
            this.message = _data["message"];
            this.trace = _data["trace"];
            this.data = _data["data"];
            this.originAccountId = _data["originAccountId"];
            this.originAccount = _data["originAccount"];
            this.originSessionId = _data["originSessionId"];
            this.createTime = _data["createTime"];
        }
    }

    static fromJS(data: any): ErrorLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["controller"] = this.controller;
        data["type"] = this.type;
        data["message"] = this.message;
        data["trace"] = this.trace;
        data["data"] = this.data;
        data["originAccountId"] = this.originAccountId;
        data["originAccount"] = this.originAccount;
        data["originSessionId"] = this.originSessionId;
        data["createTime"] = this.createTime;
        return data;
    }
}

export interface IErrorLogDto {
    id: string;
    controller?: string | undefined;
    type?: string | undefined;
    message?: string | undefined;
    trace?: string | undefined;
    data?: string | undefined;
    originAccountId: number;
    originAccount?: string | undefined;
    originSessionId: string;
    createTime: string;
}

export class MailLogDto implements IMailLogDto {
    mailLogId!: number;
    email?: string | undefined;
    fullName?: string | undefined;
    subject?: string | undefined;
    sent!: string;
    notes?: string | undefined;

    constructor(data?: IMailLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mailLogId = _data["mailLogId"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.subject = _data["subject"];
            this.sent = _data["sent"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): MailLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mailLogId"] = this.mailLogId;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["subject"] = this.subject;
        data["sent"] = this.sent;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IMailLogDto {
    mailLogId: number;
    email?: string | undefined;
    fullName?: string | undefined;
    subject?: string | undefined;
    sent: string;
    notes?: string | undefined;
}

export class PaymentIntentCreateRequest implements IPaymentIntentCreateRequest {
    items?: Item[] | undefined;

    constructor(data?: IPaymentIntentCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentIntentCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentIntentCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaymentIntentCreateRequest {
    items?: Item[] | undefined;
}

export class Item implements IItem {
    id?: string | undefined;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IItem {
    id?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
